module.exports = {
	"naslov": "Gerilski otpor",
	"slika": "fotke/1941/1941-07-cacak-uzice-diverzija.jpg",
	"opis": "Tvoj odred je izvršio prvu uspešnu diverziju na pruzi. Izbacili ste iz šina voz koji je prevozio nemačku vojsku. Poniženi, Nemci ubijaju nejač nakon svake uspešne gerilske akcije. Tvoja porodica je ostala u gradu.",
	"pitanje": "Šta ćeš učiniti?",
	"izbori": [
		{
			"opis": "Pritajiću se u šumi.",
			"link": "pritajeni"
		},
		{
			"opis": "Napadaću još žešće fašističke krvnike.",
			"link": "borba"
		},
		{
			"opis": "Vratiću se doma.",
			"link": "1941-09-24-sabac"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/hronologija/1941/09-09/podaci.json
// module id = 44
// module chunks = 0